/**
 * Adds access_token query parameter to a URL for authentication
 * Similar to mobile app implementation
 */
export function addAccessTokenToUrl(url: string, token: string | undefined): string {
  if (!url || !token) {
    return url;
  }

  try {
    // Try to parse as absolute URL
    const urlObj = new URL(url);
    urlObj.searchParams.set('access_token', token);
    return urlObj.toString();
  } catch {
    // If URL parsing fails (relative URL), append token as query parameter manually
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}access_token=${encodeURIComponent(token)}`;
  }
}
